import config from '../../../../config';

// When false, Explore is a single-product experience (Contractor only), even if
// the organization has additional products configured.
const MULTI_PRODUCT_ENABLED = !!config?.features?.multiProduct;

/**
 * Get Product Config with Universe Key at (BUSINESS or CONTRACTOR)
 * @param {object} accountData - JSON of User Account
 * @param {string} currentUniverse - 'BUSINESS' or 'CONTRACTOR'
 */
export const getUniverseConfig = (accountData, currentUniverse) => {
    if (!accountData || !accountData.organization) return null;

    let productKey = '';
    if (currentUniverse === 'CONTRACTOR') productKey = 'contractor_universe';
    if (currentUniverse === 'BUSINESS') productKey = 'business_universe';

    const subscription = accountData.organization.subscription;
    return subscription ? subscription[productKey] : null;
};

// A product is available unless explicitly unsubscribed. Soft gate: legacy
// subscriptions without the `subscribed` flag remain accessible; only an explicit
// `subscribed: false` hides the product.
const isSubscribed = (product) => !!product && product.subscribed !== false;

export const getProductConfig = (accountData) => {
    if (!accountData || !accountData.organization) return null;
    const subscription = accountData.organization.subscription;

    // Single-product mode: expose only the Contractor Universe (when subscribed) so
    // the switcher and filter content are limited to one product.
    if (!MULTI_PRODUCT_ENABLED) {
        return isSubscribed(subscription?.contractor_universe)
            ? { contractor_universe: subscription.contractor_universe }
            : {};
    }

    if (!subscription) return subscription;

    // Expose a product only if the org is subscribed to it AND (it's the default or
    // its explore feature is enabled). Unsubscribed products never appear.
    const filtered = {};
    Object.entries(subscription).forEach(([key, product]) => {
        if (!isSubscribed(product)) return;
        const isDefault = product?.default === true;
        const exploreEnabled = product?.features?.explore?.enabled === true;
        if (isDefault || exploreEnabled) {
            filtered[key] = product;
        }
    });

    return filtered;
};